import {
    Box,
    Card,
    CardMedia,
    CardContent,
    CardActionArea,
    CardHeader,
    Typography,
    Avatar
} from '@mui/material';

import Gmail from 'icons/gmail.svg';
import OneDrive from 'icons/one_drive.png';

import format from 'date-fns/format';

import { useSelector } from 'react-redux';

const RecentMessageCard = ({ id, type, user, name, dateCreated, link }) => {
    const date = dateCreated && format(new Date(dateCreated), "MM/dd/yyyy h:mm a");
    // const workspaceName = user.allWorkspaces[workspace]?.thirdPartyType; 
    // const token = useSelector((state) => state.auth.token);
    const profilePicture = user.allWorkspaces[user.currentWorkspaces[0]]?.profilePicturePath;

    const navigateToLink = () => {
        window.open(link, "_blank").focus();
    };

    return (
        <Card raised key={id} sx={{ height: "300px", width: "250px", borderRadius: "10px", background: "linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)" }} onClick={navigateToLink}>
            <CardActionArea disableRipple>
                {/*<CardHeader 
                    avatar={<Avatar src={profilePicture} sx={{ width: "34px", height: "34px" }} />} 
                    title={`${user.firstName} ${user.lastName}`} 
    titleTypographyProps={{ fontWeight: "700", maxWidth: "100%" }} />*/}
        <CardHeader/>

                <CardMedia component={Box} displa="flex" flexDirection="column" gap="1rem">                    
                    <Box display="flex" justifyContent="center" sx={{ mt: "2rem", mb: "2rem" }}>
                        <Box sx={{ display: "flex", alignItems: "end" }} gap="0.5rem">
                            {type.includes("gmail") ? (
                                <img
                                    src={Gmail}
                                    alt="Google Drive"
                                    style={{ width: "14rem", height: "4rem" }}
                                />
                            ) : (
                                <img
                                    src={OneDrive}
                                    alt="OneDrive"
                                    style={{ width: "14rem", height: "8rem" }}
                                />
                            )}
                        </Box>
                    </Box>
                </CardMedia>
                <CardContent>
                    <Box alignItems="end" justifyContent="center" height="50%">
                        <Typography
                            variant="h5"
                            fontWeight="700"
                            width="100%"
                            height="100%"
                            overflow="hidden"
                            textOverflow="ellipsis"
                        >
                            {name}
                        </Typography>
                        <br/>
                        <Typography 
                            variant="secondary" 
                            fontWeight="600" 
                        >
                            {date}
                        </Typography>
                    </Box>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default RecentMessageCard;